<mobi-breadcrumb />

@if (entity().image) {
  <div class="mobi-ui-grid is-centered view-enter-animation mobi-ui-margin-t-sm">
    <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
      <div class="hero-image-animation-wrapper">
        <mobi-media
          [entity]="entity().image"
          rounded="none"
          responsiveStyle="hero_single"
          [lazy]="false"
        />
      </div>
    </div>
  </div>
}
<div class="view-enter-animation">
  <div class="mobi-ui-margin-b-xxxl" [class.mobi-ui-margin-t-xl]="entity().image">
    <mobi-hero-text
      [title]="entity().title"
      [isCentered]="true"
      [superTitle]="entity().municipality"
      [lead]="entity().desc"
    />
  </div>
  @if (entity().paidout) {
    <mobi-text
      [data]="
        'beitrag_der_mobiliar'
          | texts
            : {
                context: 'frontend',
                default: 'Beitrag der Mobiliar',
              }
      "
      class="mobi-ui-font-bold block mobi-ui-centered"
    />
    <mobi-text
      [data]="'CHF ' + formatNumber(entity().paidout, '0,0')"
      class="mobi-ui-padding-y-sm block mobi-ui-font-bold mobi-ui-text-inked mobi-ui-font-h2 mobi-ui-centered"
    />
  }
</div>
<div class="mobi-ui-margin-b-xxxl mobi-ui-flex justify-center view-enter-animation">
  @if (entity().danger) {
    <div>
      @defer (hydrate never) {
        <mobi-misc-item
          [title]="
            'gefahrentyp'
              | texts
                : {
                    context: 'frontend',
                    default: 'Gefahrentyp',
                  }
          "
          [content]="entity().danger"
          icon="damage_part"
        />
      }
    </div>
  }
  @if (entity().status) {
    @if (entity().danger) {
      <div class="mobi-ui-separator-vertical-minor"></div>
    }
    <div>
      @defer (hydrate never) {
        <mobi-misc-item
          [title]="
            'status'
              | texts
                : {
                    context: 'frontend',
                    default: 'Status',
                  }
          "
          [content]="entity().status"
          icon="hourglass"
        />
      }
    </div>
  }
  @if (entity().costs) {
    @if (entity().status || entity().danger) {
      <div class="mobi-ui-separator-vertical-minor"></div>
    }
    <div>
      @defer (hydrate never) {
        <mobi-misc-item
          [title]="
            'costs'
              | texts
                : {
                    context: 'frontend',
                    default: 'Projektkosten',
                  }
          "
          [content]="'CHF ' + formatNumber(entity().costs, '0,0')"
          icon="money_bag"
        />
      }
    </div>
  }
</div>
